// extracted by mini-css-extract-plugin
export default {"wrapper":"DriverRecommendation_wrapper__6JtgR"};